import '../assets/css/highlights.css'
const HighlightsV2 = () => {
    return (
        <div className="d-flex justify-content-center align-items-center vh-100 w-100">
            <div className="position-relative w-100 mw-80" style={{ maxWidth: '800px', aspectRatio: '16/9' }}>
                <iframe
                    className="position-absolute top-0 start-0 w-100 h-100"
                    src="https://www.youtube.com/embed/CUqtLsLrIlc?si=5igNhvmOti6yrgHo&rel=0&modestbranding=1&controls=1&hd=1"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    )
}

export default HighlightsV2;